import { MutedAlert } from '@app/components/MutedAlert';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { FormattedMessage } from 'react-intl';
import { youtubePlaylistMessages } from './youtube-playlist-messages';
/**
 * Warning shown when the station's YouTube connection lacks playlist management scope.
 */
export function YoutubePlaylistsNoPermissionsAlert() {
  return (
    <MutedAlert
      severity="info"
      icon={<FeedbackOutlinedIcon fontSize="small" color="warning" />}
      sx={{ px: 1, py: 0, fontSize: 'small' }}
    >
      <FormattedMessage {...youtubePlaylistMessages.noManagePermissions} />
    </MutedAlert>
  );
}
